import React, { createContext, useContext, useEffect } from "react";
import useUser from "../hooks/user";
import { useLocation } from "react-router-dom";
import appAxios, { showErrorNotification } from "../services/axios";

export const CurrentUserContext = createContext();
export const useUserContext = () => useContext(CurrentUserContext);

export const CurrentUserProvider = ({ children }) => {
  const { currentUser, loginUser, logoutUser, refetchCurrentUser } = useUser(
    {},
  );

  return (
    <CurrentUserContext.Provider
      value={{ currentUser, loginUser, logoutUser, refetchCurrentUser }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

export const CurrentUserUpdater = () => {
  const location = useLocation();
  const { refetchCurrentUser } = useUserContext();

  useEffect(() => {
    refetchCurrentUser();
  }, [location]);

  useEffect(() => {
    const id = appAxios.interceptors.response.use(
      (response) => {
        // skip if this was the "get current user" call:
        if (!response.config.url?.endsWith("/api/user/current")) {
          refetchCurrentUser();
        }
        return response;
      },
      (error) => {
        showErrorNotification(error);
        return Promise.reject(error);
      },
    );

    return () => {
      appAxios.interceptors.response.eject(id);
    };
  }, [refetchCurrentUser]);

  return null;
};
